import { useTranslation } from '@common/Hooks/useTranslation';
import { scrollToTop } from '@helpers/scroll';

import '../styles/FooterBackToTop.scss';

export function FooterBackToTop() {
    const translate = useTranslation();
    const handleScroll = () => scrollToTop('smooth');

    return (
        <button
            className="react-footer-back-to-top"
            onClick={handleScroll}
        >
            {translate('footer.back_to_top.mobile.link')}
        </button>
    );
}
